module.exports = __webpack_public_path__ + "static/img/avatar-normal.fd319951.png";